import { useTranslation } from "react-i18next";
import MainCard from "../MainCard";
import RemoteParticipantView from "../RemoteParticipantView";
import useIsMobile from "../../utils/useIsMobile";
import React, { useEffect, useRef, useState } from "react";
import { useAppContext } from "../../AppContextDef";
import CharacterView from "../CharacterView";
import ConfirmBox from "../ConfirmBox";
import imageSrc from "../../repeat_audio_icon.png";
import { fontMap } from "../../utils/common";
import { useParticipant, usePubSub } from "@videosdk.live/react-sdk";

const VideoConsentSection = ({ formattedTime, characterJoined }) => {
  const {
    isTimerRunningData: isTimerRunning,
    journeyConfigData,
    timerData: timer,
    currentPage,
    agreedData,
    selectedLang,
    openVideoErr,
    openVideoFailErr,
    setOpenVideoErr,
    setOpenVideoFailErr,
    isJourneyEnded,
    openDeviceChange,
    setOpenDeviceChange,
    openTextMatchErr,
    setOpenTextMatchErr,
    accuracy
  } = useAppContext();
  const { t, i18n } = useTranslation();
  const isMobile = useIsMobile();
  const [messageSent, setMessageSent] = useState(false);

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };
  const [isCharacterSpeaking, setIsCharacterSpeaking] = useState(false)
  // const { getVideoStats } = useParticipant("customer")
  // const [isBadNetwork, setIsBadNetwork] = useState(false);
  // const frameRatesRef = useRef([]);

  // const { publish: badNetworkPublish } = usePubSub(`BAD_NETWORK`);



  // const getParticipantStats = async () => {
  //   try {
  //     const stats = await getVideoStats();

  //     const framerate = stats ? stats[0]?.size?.framerate : 0;

  //     frameRatesRef.current = [...frameRatesRef.current, framerate].slice(-5);

  //     const allLow = frameRatesRef.current.every(rate => rate < 5);
  //     const allHigh = frameRatesRef.current.every(rate => rate >= 5);

  //     if (allLow) {
  //       badNetworkPublish({ isBadNetwork: true }, { persist: true });
  //       console.log(`Customer is experiencing network issues. Network event published at ${new Date().toLocaleString('en-IN', { timeZone: 'Asia/Kolkata' })}`);
  //       setIsBadNetwork(true)
  //     }
  //     if (allHigh) {
  //       badNetworkPublish({ isBadNetwork: false }, { persist: true });
  //       setIsBadNetwork(false)
  //     }

  //   } catch (err) {
  //     console.error("Failed to get stats:", err);
  //   }
  // };

  // useEffect(() => {
  //   const interval = setInterval(() => {
  //     getParticipantStats();
  //   }, 1000);

  //   return () => clearInterval(interval);
  // }, []);


  useEffect(() => {
    changeLanguage(selectedLang?.lang);
  }, [selectedLang]);

  let videoConsentText = journeyConfigData?.clientScript;

  const isEnabled =
    agreedData &&
    !isCharacterSpeaking &&
    messageSent &&
    !isTimerRunning?.isRunning

  const fontFamilyCSS = fontMap[selectedLang?.lang] || "Lato";

  return (
    <div className="flex flex-col max-h-screen md:h-full w-full bg-white py-0 px-0 md:py-10 md:px-9 lg:px-8 xl:px-14">
      <MainCard
        formattedTime={formattedTime}
        mainTitle={t("Video Consent")}
        mainClassCss={
          "flex flex-1 flex-col h-screen justify-between md:border md:rounded-xl py-3 px-3 md:py-10 md:px-9 lg:px-8 xl:px-14"
        }
        mainTitleCss={
          "md:flex md:flex-1 text-center justify-center hidden text-2xl lg:text-4xl text-black-200 font-extrabold mb-0"
        }
        FirstSection={
          <div
            className={`md:mt-9 ${isMobile && "sticky top-40"} px-2 md:px-0`}
          >
            <RemoteParticipantView />
            <CharacterView
              isRecorder={true}
              characterJoined={characterJoined}
              currentPage={currentPage}
              setIsCharacterSpeaking={setIsCharacterSpeaking}
              isCharacterSpeaking={isCharacterSpeaking}
              agreed={agreedData}
              messageSent={messageSent}
              setMessageSent={setMessageSent}
              selectedLang={selectedLang}
              message={`${t(
                "Please record your video consent by clicking Start and clearly reading the text displayed on the screen. When you're done, click Stop to complete the process."
              )}`}
            />

            <div>
              {isTimerRunning?.isRunning && (
                <div
                  style={{ fontFamily: fontFamilyCSS }}
                  className="mt-5 text-base md:text-lg font-bold text-left md:text-center"
                >
                  {t("timeRemaining", { timer })}
                </div>
              )}

              {isJourneyEnded ? (
                <div className="mt-4">
                  <div className=" flex justify-center items-center w-full h-11 ">
                    <div
                      style={{ borderTopColor: "#EA7617" }}
                      className="animate-spin  ease-linear rounded-full border-4  border-gray-100 h-12 w-12"
                    ></div>
                  </div>
                  <p
                    style={{ fontFamily: fontFamilyCSS }}
                    className="text-center text-base md:text-lg text-black-150 mt-3"
                  >
                    {`${t("Please wait while we verify your recording")}...`}
                  </p>
                </div>
              ) : (
                videoConsentText && (
                  <p
                    style={{ fontFamily: fontFamilyCSS }}
                    className={`text-left md:text-center text-base font-bold ${isTimerRunning?.isRunning ? "mt-3" : "mt-6"
                      }`}
                  >
                    {videoConsentText}
                  </p>
                )
              )}
            </div>
          </div>
        }
        SecondSection={
          isJourneyEnded ? null : (
            <div className="flex items-center justify-center mt-8 px-2 md:px-0">
              {!isTimerRunning?.isRunning ? (
                <button
                  disabled={!isEnabled}
                  style={{ fontFamily: fontFamilyCSS }}
                  className={`disabled:bg-opacity-15 disabled:cursor-not-allowed bg-orange-150 text-white p-3 rounded-md w-full font-bold md:max-w-max`}
                >
                  {t("Start")}
                </button>
              ) : (
                <button
                  style={{ fontFamily: fontFamilyCSS }}
                  className="bg-gray-100 text-black-150 p-3 rounded-md border border-darkGray-150 ml-3 w-full font-bold md:max-w-max"
                >
                  {t("Stop")}
                </button>
              )}
              <button
                style={{ fontFamily: fontFamilyCSS }}
                className={`bg-blue-250 text-blue-150 flex items-center justify-center p-3 ml-3 rounded-md font-bold max-w-max`}
              >
                <img src={imageSrc} alt="icon" className="w-6 h-6" />
              </button>
            </div>
          )
        }
      />
      {openVideoErr && (
        <ConfirmBox
          open={openVideoErr}
          setOpen={setOpenVideoErr}
          buttonText={`${t("Record again")}`}
          text={` ${t(
            "The spoken text is inaccurate. Please try recording again."
          )}`}
          buttonHandler={() => {
            setOpenVideoErr(false);
          }}
          extraButtonText={`${t("Return to homepage")}`}
          extraButtonHandler={() => {
            setOpenVideoErr(false);
          }}
          selectedLang={selectedLang}
          thirdButtonText={`${t("Submit for Validation")}`}
          thirdButtonHandle={() => {
            setOpenVideoErr(false);
          }}
          thirdButtonCondition={accuracy > 60 ? true : false}


        />
      )}
      {openTextMatchErr && (
        <ConfirmBox
          open={openTextMatchErr}
          setOpen={setOpenTextMatchErr}
          text={t(
            "Oops! Some error occurred. Please reach out to our sales representative or write to us at vidassure@iciciprulife.com [ERR099]"
          )}
          buttonText={t("Return to homepage")}
          buttonHandler={async () => {
            setOpenTextMatchErr(false);
          }}
        />
      )}
      {openVideoFailErr && (
        <ConfirmBox
          open={openVideoFailErr}
          setOpen={setOpenVideoFailErr}
          buttonText={`${t("Return to homepage")}`}
          buttonHandler={() => {
            setOpenVideoFailErr(false);
          }}
          text={`${t(
            "Your video consent was not successfully recorded. Please restart the process and try again."
          )}`}
          selectedLang={selectedLang}
        />
      )}
      {openDeviceChange && (
        <ConfirmBox
          open={openDeviceChange}
          setOpen={setOpenDeviceChange}
          buttonText={`${t("Record Again")}`}
          buttonHandler={async () => {
            setOpenDeviceChange(false)
          }}
          text={`${t(
            "Your video consent could not be recorded due to a device change. Please try again."
          )}`}
        />
      )}
      {/* The "network unstable" dialog is rendered globally in RecordingContainer
          so it appears on every recorder page, not just here. */}
    </div>
  );
};

export default VideoConsentSection;
